import { render } from "./CookiesDomPrint.vue?vue&type=template&id=1f2ec54c&scoped=true"
import script from "./CookiesDomPrint.vue?vue&type=script&lang=js"
export * from "./CookiesDomPrint.vue?vue&type=script&lang=js"

import "./CookiesDomPrint.vue?vue&type=style&index=0&id=1f2ec54c&lang=css"
import "./CookiesDomPrint.vue?vue&type=style&index=1&id=1f2ec54c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2ec54c"]])

export default __exports__